'use strict';

var jsxRuntime = require('react/jsx-runtime');

const ShieldConfirm = ({ disabled = false })=>{
    if (disabled) {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            "data-testid": "design-system-productIcon-icon-shield_confirm--disabled",
            children: [
                jsxRuntime.jsx("path", {
                    d: "M11 15L30 8L49 15V30.7205C49 38.7674 44.1774 46.0306 36.7611 49.1532L36.2089 49.3857C32.2384 51.0575 27.7616 51.0575 23.7911 49.3857L23.2389 49.1532C15.8226 46.0306 11 38.7674 11 30.7205V15Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M16 19.0909L30 14L44 19.0909V30.0625C44 36.1892 40.3131 41.714 34.6555 44.0653V44.0653C31.6754 45.3037 28.3246 45.3037 25.3445 44.0653V44.0653C19.6869 41.714 16 36.1892 16 30.0625V19.0909Z",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M26 28.6L29.375 32.5L35 26",
                    stroke: "white",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        "data-testid": "design-system-productIcon-icon-shield_confirm",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M11 15L30 8L49 15V30.7205C49 38.7674 44.1774 46.0306 36.7611 49.1532L36.2089 49.3857C32.2384 51.0575 27.7616 51.0575 23.7911 49.3857L23.2389 49.1532C15.8226 46.0306 11 38.7674 11 30.7205V15Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M16 19.0909L30 14L44 19.0909V30.0625C44 36.1892 40.3131 41.714 34.6555 44.0653V44.0653C31.6754 45.3037 28.3246 45.3037 25.3445 44.0653V44.0653C19.6869 41.714 16 36.1892 16 30.0625V19.0909Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M26 28.6L29.375 32.5L35 26",
                stroke: "white",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

module.exports = ShieldConfirm;
